import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../../utils/TestIds';
import { emptyColumnsState } from '../tableCore/columns/columnsState';
import { useColumnFloors } from '../tableCore/columns/useColumnFloors';
import { STATIC_EDGE_PADDING } from '../tableCore/table.constants';
import styles from '../tableCore/table.module.scss';
import { TableHeader } from '../tableCore/TableHeader';
import { TableRow } from '../tableCore/TableRow';
import { TableSurface } from '../tableCore/TableSurface/TableSurface';
import { useTableLayout } from '../tableCore/useTableLayout/useTableLayout';
export function SummaryTable(param) {
    let { mainColumn, columns, items, getRowId, onRowClick, rowHref, now, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const columnsState = useMemo(()=>emptyColumnsState(), []);
    const { floors, measurer } = useColumnFloors({
        mainColumn,
        columns,
        headerLabelVariant: 'paragraph1'
    });
    const { scrollerRef, columns: resolved, minWidth } = useTableLayout({
        mainColumn,
        columns,
        columnsState,
        floors,
        // WHY: a summary row pads 4px on each side, like a static table's, so its columns leave those 8px free.
        reservedWidth: STATIC_EDGE_PADDING,
        padsEndEdge: false
    });
    return /*#__PURE__*/ _jsx(TableSurface, {
        scrollerRef: scrollerRef,
        framed: false,
        interactive: false,
        scrollable: false,
        clipsColumns: true,
        testId: testId,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                measurer,
                /*#__PURE__*/ _jsx(TableHeader, {
                    columns: resolved,
                    minWidth: minWidth,
                    className: styles.plainHeader,
                    plainLabels: true,
                    testId: testIds.header()
                }),
                items.map((row)=>{
                    const rowId = getRowId(row);
                    return /*#__PURE__*/ _jsx(TableRow, {
                        row: row,
                        rowId: rowId,
                        columns: resolved,
                        minWidth: minWidth,
                        rowStyle: "unified",
                        compact: true,
                        now: now,
                        onRowClick: onRowClick,
                        rowHref: rowHref === null || rowHref === void 0 ? void 0 : rowHref(row),
                        testId: testIds.row(rowId)
                    }, rowId);
                })
            ]
        })
    });
}
